import { type PropsWithChildren, type RefObject, useEffect } from 'react'
import {
  PlaybackProvider,
  usePlaybackData,
} from 'components/PlaybackProvider/PlaybackContext'

const MIN_VISIBLE_RATIO = 0.5

type Props = PropsWithChildren<{ targetRef: RefObject<HTMLElement | null> }>

function MostlyVisibleArea({ targetRef, children }: Props) {
  const { setPlaybackSuspended } = usePlaybackData()

  useEffect(() => {
    const target = targetRef.current
    if (!target) return

    const observer = new IntersectionObserver(
      ([entry]) =>
        setPlaybackSuspended(entry.intersectionRatio < MIN_VISIBLE_RATIO),
      { threshold: MIN_VISIBLE_RATIO }
    )
    observer.observe(target)

    return () => observer.disconnect()
  }, [targetRef, setPlaybackSuspended])

  return children
}

// Plays its video only while at least half of the target is on screen.
export default function MostlyVisiblePlayback({ targetRef, children }: Props) {
  return (
    <PlaybackProvider>
      <MostlyVisibleArea targetRef={targetRef}>{children}</MostlyVisibleArea>
    </PlaybackProvider>
  )
}
